import React, { useState } from 'react';
import { SimulatorOfferModel, TreatmentModel } from './models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faEnvelope, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';


type Props = {
    treatment: TreatmentModel | null;

};



export class LeadTreatment extends React.Component<Props> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {

        moment.locale('he');
    }

    getNumberOrZero(int: number | undefined | null) {
        if (int != null && int != undefined)
            return int;
        return 0;
    }

    closeLead() {

    }

    render() {


        return (



            <>
                {this.props.treatment != null ? (
                    <div className="details-content-row flex-centered flex-space-between">
                        <div className="cell date">
                            <div>{moment(this.props.treatment.eventDate).format('DD-MM-YYYY')}</div>
                            <div>{moment(this.props.treatment.eventDate).format('HH:mm')}</div>
                        </div>
                        <div className="cell status">
                            {this.props.treatment.treatmentTypeIcon ? (
                                <>
                                    {this.props.treatment.treatmentTypeIcon == 'fa-envelope' ? (
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    ) : (
                                        <FontAwesomeIcon icon={faWhatsapp} />
                                    )}
                                </>
                            ) :
                                (<></>)}
                            {/* <div className={this.props.treatment.alertDate!=null && this.props.treatment.alertDate>new Date()?"hourglass":(this.props.treatment.assignmentStatus==null||(this.props.treatment.assignmentStatus!=0 && this.props.treatment.assignmentStatus!=3)?"checked":"bell")}></div>  */}
                        </div>
                        <div className="cell text-label">
                            {this.props.treatment.topic}
                        </div>
                        <div className="cell long">

                            {this.props.treatment.note != null && this.props.treatment.note.indexOf('http://') > -1 ? (
                                <a target="_blank" href={this.props.treatment.note}>{this.props.treatment.note}</a>
                            ) : this.props.treatment.note}
                        </div>
                        <div className="cell actions">
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                            <div className="icon left-arrow toggle-row"></div>
                        </div>
                    </div>
                ) : ""}

            </>

        );
    }
}
